export default "__VITE_ASSET__DMGsjDWN__"